import { makeOverlayContext } from '@objectiv/schema';
import { useVisibilityTracker } from '@objectiv/tracker-react';
import { AnimatePresence } from 'motion/react';
import { useEffect } from 'react';

import { useProfile } from '../../../api/queries/useProfile';
import { ChatInterface } from '../../../components/chat/interface';
import { OnboardingModal } from '../../../components/chat/introduction/modal';
import { useAudioStore } from '../../../features/assistant/stores/useAudioStore';
import { useChatStore } from '../../../stores/chatStore';

const AssistantPage = () => {
  const sessionId = useChatStore.use.sessionId();
  const isOnboarded = useChatStore.use.isOnboarded();

  const initAudio = useAudioStore.use.initAudio();
  const stopAudio = useAudioStore.use.stopAudio();

  const trackModalVisibility = useVisibilityTracker();

  const { data: profile } = useProfile();

  const onModalOpen = () => {
    trackModalVisibility({
      locationStack: [makeOverlayContext({ id: 'chat-onboarding-dialog' })],
      isVisible: true,
    });
  };

  const onModalClose = () => {
    trackModalVisibility({
      locationStack: [makeOverlayContext({ id: 'chat-onboarding-dialog' })],
      isVisible: false,
    });
  };

  useEffect(() => {
    initAudio();
    return () => {
      stopAudio(); // Cleanup when navigating away
    };
  }, []);

  const isModalOpen = !sessionId && !isOnboarded;

  if (!profile || !profile.result) {
    return null;
  }

  return (
    <>
      <AnimatePresence>
        {isModalOpen && <OnboardingModal onOpen={onModalOpen} isOpen={isModalOpen} onClose={onModalClose} />}
      </AnimatePresence>
      <ChatInterface />
    </>
  );
};

export { AssistantPage };
